import React, { useState } from "react";
import "../../Styles/YuvagalamForm.css";

const AdminYuvagalamForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    relation: "",
    age: "",
    qualification: "",
    aadhaar: "",
    mobile: "",
    bankAccount: "",
    ifsc: "",
    amount: "",
    village: "",
    mandal: "",
    date: "",
    status: "",
    remarks: "",
    photo: null,
    document: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  return (
    <div className="yuvagalam-form-container">
      <div className="yuvagalam-form-card">
        <div className="yuvagalam-form-header">
          <h2>Add New Yuvagalam Beneficiary</h2>
          <p>20 lakh jobs for youth over five years, with unemployment support</p>
          <button
            className="yuvagalam-back-btn"
            onClick={() => window.history.back()}
          >
            Back
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="yuvagalam-form-grid">

            <div className="yuvagalam-form-group">
              <label>Beneficiary Name *</label>
              <input
                type="text"
                name="name"
                placeholder="Enter Beneficiary Name"
                onChange={handleChange}
              />
            </div>

            <div className="yuvagalam-form-group">
              <label>Relation *</label>
              <input
                type="text"
                name="relation"
                placeholder="Ex: S/O, D/O"
                onChange={handleChange}
              />
            </div>

            <div className="yuvagalam-form-group">
              <label>Age *</label>
              <input
                type="number"
                name="age"
                placeholder="Enter Age"
                onChange={handleChange}
              />
            </div>

            <div className="yuvagalam-form-group">
              <label>Qualification *</label>
              <input
                type="text"
                name="qualification"
                placeholder="Ex: B.Tech, Degree, ITI"
                onChange={handleChange}
              />
            </div>

            <div className="yuvagalam-form-group">
              <label>Aadhaar Number *</label>
              <input
                type="text"
                name="aadhaar"
                placeholder="Enter 12-digit Aadhaar Number"
                maxLength="12"
                onChange={handleChange}
              />
            </div>

            <div className="yuvagalam-form-group">
              <label>Mobile Number *</label>
              <input
                type="tel"
                name="mobile"
                placeholder="Enter Mobile Number"
                maxLength="10"
                onChange={handleChange}
              />
            </div>
             <div className="yuvagalam-form-group">
              <label>Voter Id *</label>
              <input
                type="text"
                name="voterId"
                placeholder="Enter Voter ID"
                maxLength="10"
                onChange={handleChange}
              />
            </div>


            <div className="yuvagalam-form-group">
              <label>Bank Account Number *</label>
              <input
                type="text"
                name="bankAccount"
                placeholder="Enter Bank Account Number"
                onChange={handleChange}
              />
            </div>

            <div className="yuvagalam-form-group">
              <label>IFSC Code *</label>
              <input
                type="text"
                name="ifsc"
                placeholder="Enter IFSC Code"
                onChange={handleChange}
              />
            </div>

            <div className="yuvagalam-form-group">
              <label>Monthly Allowance (₹) *</label>
              <input
                type="number"
                name="amount"
                placeholder="Enter Amount"
                onChange={handleChange}
              />
            </div>

            <div className="yuvagalam-form-group">
              <label>Village *</label>
              <input
                type="text"
                name="village"
                placeholder="Enter Village"
                onChange={handleChange}
              />
            </div>

            <div className="yuvagalam-form-group">
              <label>Mandal *</label>
              <select name="mandal" onChange={handleChange}>
                <option>Select Mandal</option>
                <option>Kandukur</option>
                <option>Gudluru</option>
                <option>Ulavapadu</option>
              </select>
            </div>

            <div className="yuvagalam-form-group">
              <label>Date *</label>
              <input
                type="date"
                name="date"
                onChange={handleChange}
              />
            </div>

            <div className="yuvagalam-form-group">
              <label>Status *</label>
              <select name="status" onChange={handleChange}>
                <option>Select Status</option>
                <option>Approved</option>
                <option>Pending</option>
              </select>
            </div>

            <div className="yuvagalam-form-group">
              <label>Upload Photo *</label>
              <input
                type="file"
                name="photo"
                accept="image/*"
                onChange={handleChange}
              />
            </div>

            <div className="yuvagalam-form-group">
              <label>Upload Supporting Document</label>
              <input
                type="file"
                name="document"
                accept=".pdf,image/*"
                onChange={handleChange}
              />
            </div>

          </div>

          <div className="yuvagalam-form-group yuvagalam-full-width">
            <label>Remarks</label>
            <textarea
              rows="4"
              name="remarks"
              placeholder="Enter Remarks"
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="yuvagalam-btn-group">
            <button type="submit" className="yuvagalam-submit-btn">
              Submit
            </button>
            <button type="reset" className="yuvagalam-reset-btn">
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminYuvagalamForm;